import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { RaisedButton } from 'material-ui';
import _ from 'lodash';
import { lifecycle, compose } from 'recompose';
import { fetchSmlinks } from 'dash-front/campaign/actions/smlinks';
import { fetchCampaignsWithPagination } from 'dash-front/campaign/actions/withPagination';
import List from '../../components/List/CampaignsList';
import { withCampaigns } from 'dash-front/campaign/enhancers';

const listEnhancer = compose(
    withCampaigns,
    connect(state => ({ user: state.user })),
    lifecycle({
        componentDidMount() {
            const { dispatch, user: { _id } } = this.props;
            dispatch(fetchCampaignsWithPagination(_id));
            dispatch(fetchSmlinks());
        }
    })
);

const ListEnhanced = listEnhancer(List);

const Scene = () => (
    <div>
        <Link to={'/campaigns/create'}>
            <RaisedButton primary style={{ margin: '12px 0' }} label={'Create campaign'} />
        </Link>
        <ListEnhanced />
    </div>
);

export default Scene;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/List.js
 **/